// Subscription tier limits
export const TIER_LIMITS = {
  free: {
    maxScrapbooks: 1,
    maxPagesPerScrapbook: 20,
    maxStorageBytes: 100 * 1024 * 1024, // 100 MB
    maxStorageDisplay: '100 MB',
  },
  pro: {
    maxScrapbooks: Infinity,
    maxPagesPerScrapbook: Infinity,
    maxStorageBytes: 10 * 1024 * 1024 * 1024, // 10 GB
    maxStorageDisplay: '10 GB',
  },
} as const;

// Pricing
export const PRICING = {
  pro: {
    monthly: 9.99,
    currency: 'USD',
    features: [
      'Unlimited scrapbooks',
      'Unlimited pages',
      '10 GB storage',
      'Priority support',
    ],
  },
  free: {
    monthly: 0,
    currency: 'USD',
    features: [
      '1 scrapbook',
      '20 pages per scrapbook',
      '100 MB storage',
      'All editing features',
      'Share via link',
    ],
  },
} as const;

// Image processing
export const IMAGE_SIZES = {
  thumbnail: { maxDimension: 200, quality: 80 },
  preview: { maxDimension: 800, quality: 85 },
  full: { maxDimension: 2000, quality: 90 },
} as const;

export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
] as const;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

// Canvas defaults
export const DEFAULT_PAGE_SIZE = {
  width: 1200,
  height: 1200,
} as const;

// Auth
export const AUTH_TOKEN_EXPIRY_MINUTES = 15;
export const SESSION_EXPIRY_DAYS = 60;
export const OTP_LENGTH = 6;
export const MAX_OTP_ATTEMPTS = 5;

// Rate limits
export const RATE_LIMITS = {
  authRequest: { max: 3, window: '1 minute' },
  authVerify: { max: 5, window: '15 minutes' },
  upload: { max: 10, window: '1 minute' },
  general: { max: 100, window: '1 minute' },
} as const;

// API routes (for frontend reference)
export const API_ROUTES = {
  auth: {
    request: '/api/v1/auth/request',
    verifyLink: '/api/v1/auth/verify-link',
    verifyOtp: '/api/v1/auth/verify-otp',
    logout: '/api/v1/auth/logout',
    me: '/api/v1/auth/me',
  },
  scrapbooks: {
    list: '/api/v1/scrapbooks',
    create: '/api/v1/scrapbooks',
    get: (id: string) => `/api/v1/scrapbooks/${id}`,
    update: (id: string) => `/api/v1/scrapbooks/${id}`,
    delete: (id: string) => `/api/v1/scrapbooks/${id}`,
    share: (id: string) => `/api/v1/scrapbooks/${id}/share`,
    pages: (id: string) => `/api/v1/scrapbooks/${id}/pages`,
    reorderPages: (id: string) => `/api/v1/scrapbooks/${id}/pages/reorder`,
  },
  pages: {
    get: (id: string) => `/api/v1/pages/${id}`,
    update: (id: string) => `/api/v1/pages/${id}`,
    delete: (id: string) => `/api/v1/pages/${id}`,
  },
  assets: {
    upload: '/api/v1/assets/upload',
    get: (id: string) => `/api/v1/assets/${id}`,
    delete: (id: string) => `/api/v1/assets/${id}`,
  },
  shared: {
    get: (token: string) => `/api/v1/shared/${token}`,
    delete: (id: string) => `/api/v1/shared/${id}`,
  },
  subscription: {
    checkout: '/api/v1/subscription/create-checkout',
    portal: '/api/v1/subscription/portal',
  },
} as const;
